export const formatBRL = (value) =>
  (value ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const SUBCATEGORIAS_CELULARES = [
  "Iphones Vitrine",
  "Iphones Lacrados",
  "Xiaomi",
  "Poco",
  "Oppo",
  "Tecno",
  "Honor",
  "Infinix",
  "Realme",
];

export const categoryLabel = (cat) =>
  ({ celulares: "Celulares", acessorios: "Acessórios", telas: "Telas" }[cat] || cat);
